'use client';
import { createProps, splitProps } from '@chakra-ui/utils';

const progressProps = createProps()([
  "hasStripe",
  "isAnimated",
  "isIndeterminate",
  "max",
  "min",
  "value"
]);
const splitProgressProps = (props) => {
  return splitProps(props, progressProps);
};

export { progressProps, splitProgressProps };
